import usePrefix from '@/hooks/usePrefix';
import React from 'react';
import { ControlLabel, FormGroup } from 'rsuite';
import { Checkbox, FormControl } from '@/components/formik-rsuite';
import { TypeAttributes } from 'rsuite/lib/@types/common';

const BicesterCardCheckbox = ({
  className,
  isEdit = true,
  required = false,
  label,
  formKey,
  errorPlacement,
  labelWeight,
  contentWeight,
  onCheck,
}: {
  className?: string;
  /** 编辑状态 */
  isEdit?: boolean;
  /** 是否必填 */
  required?: boolean;
  label: string;
  formKey: string; // 与field.name一致，只读数据中也要传个key，否则accepter报错
  value?: string; // field.value为空时显示的value，一般用于只读数据
  errorPlacement?: TypeAttributes.Placement8;
  /** label部分的flex占比 */
  labelWeight?: number;
  /** content部分的flex占比 */
  contentWeight?: number;
  onCheck?: (key: string, checked: boolean) => void;
}) => {
  const { prefix, classname } = usePrefix('bicester-card-item');

  return (
    <div className={`bicester-card-item-wrap ${className ?? ''}`}>
      <FormGroup className={`${classname} bicester-card-checkbox justify-end`}>
        {label && (
          <ControlLabel
            className={prefix('label')}
            style={{ ...(labelWeight && { flex: labelWeight }) }}
          >
            <div className={prefix('label-text')}>{label}</div>
            <div
              className={`${prefix('label-divider')} ${isEdit && required ? 'required' : ''}`}
            ></div>
          </ControlLabel>
        )}
        <div
          className={`text-left ${prefix('content-wrap')} ${
            isEdit ? prefix('content-wrap-isedit') : ''
          }`}
          style={{ ...(contentWeight && { flex: contentWeight }) }}
        >
          {isEdit ? (
            <FormControl
              accepter={Checkbox}
              style={{ marginLeft: 0 }}
              name={formKey}
              errorPlacement={errorPlacement}
              onCheck={onCheck}
              disabled={!isEdit}
            />
          ) : (
            <FormControl
              name={formKey}
              accepter={({ field }) => (
                <div className={prefix('content-wrap-text')}>{field.value ? '是' : '否'}</div>
              )}
            />
          )}
        </div>
      </FormGroup>
    </div>
  );
};

export default BicesterCardCheckbox;
